// extracted by mini-css-extract-plugin
export default {"shell":"PageShell_shell__iD7Ar"};